import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.js';
import { BASENAME } from './lib/endereco.js';
import './index.css';

/*
 * O `basename` DEIXOU de ser constante, e o motivo é o host (`0276`).
 *
 * No painel a SPA é servida em `/aluno/` pela mesma API que serve o painel — sem
 * o basename, o React Router montaria rotas na raiz e o carve-out do `spaPlugin`
 * devolveria o index do painel na primeira navegação recarregada.
 *
 * No domínio próprio da área (`curso.cliente.com.br`) ela É a raiz, e o mesmo
 * basename ali quebraria toda rota. Quem decide é `lib/endereco.ts`, a partir do
 * que o servidor injetou no documento — e ele decide UMA vez, aqui, para não
 * haver duas ideias de onde a aplicação mora.
 */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter basename={BASENAME}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
